<template>
    <div>
        <span>{{ getStatus }}</span>
    </div>
</template>

<script>

import Vue from "vue";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
    computed: {
        getStatus() {
            let value = this.row[this.column.data];

            switch (value) {
                case 'error':
                    return Vue.prototype.$translate.text('Error');
                case 'pending':
                    return Vue.prototype.$translate.text('In progress...');
                case 'done':
                    return Vue.prototype.$translate.text('Ready');
                case 'new':
                    return Vue.prototype.$translate.text('New');
                default:
                    return value;
            }
        }
    }
}

</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// QueueStatusComponent.vue?05deaa3e